import React, { ReactElement, useRef, useState } from 'react'
import { CrossClientQueryLogicalQuestionDecomposition, CrossClientQueryResultMatch, CrossClientQueryResultMatches } from '../../../../models/CrossClient'
import { ReactComponent as MatchIcon } from '../../../../assets/images/cross-client-match.svg'
import { ReactComponent as NoMatchIcon } from '../../../../assets/images/cross-client-no-match.svg'
import { CrossClientQueryResultCellProps } from './types'
import { OverlayTrigger, Popover } from 'react-bootstrap'
import classNames from 'classnames'
import { Tooltip } from '../../../../components/Tooltip/Tooltip'

interface CrossClientQueryResultMatchCellProps extends CrossClientQueryResultCellProps {
  decomposition: CrossClientQueryLogicalQuestionDecomposition
}

const MATCH_MAPPING: Record<CrossClientQueryResultMatch, { icon: ReactElement; label: string; className: string }> = {
  [CrossClientQueryResultMatches.MATCH]: { icon: <MatchIcon />, label: 'Match', className: 'cross-client-match' },
  [CrossClientQueryResultMatches.NO_MATCH]: { icon: <NoMatchIcon />, label: 'No match', className: 'cross-client-no-match' },
}

export const CrossClientQueryResultMatchCell: React.FC<CrossClientQueryResultMatchCellProps> = ({ decomposition, result }) => {
  const { match, answers } = result
  const { icon: matchIcon, label: matchLabel, className: matchClassName } = MATCH_MAPPING[match] ?? { icon: null, label: '' }

  const [popoverDisplayed, setPopoverDisplayed] = useState<boolean>(false)

  const popover = (
    <Popover id='popover-match' className='cross-client-match-popover'>
      <Popover.Body>
        <div className='d-flex flex-column gap-3'>
          <div className='paragraph-medium medium'>Match details</div>
          {!answers ? (
            <div>No data available for this client</div>
          ) : (
            decomposition.atomicClauses.map((clause, index) => {
              const answer = answers[index]
              return (
                <div key={index} className='d-flex flex-column gap-1'>
                  <div className='d-flex gap-2'>
                    <i className='bi bi-x-diamond-fill zocks-text-info' />
                    <div className='paragraph-small medium'>{clause.questionForm}</div>
                  </div>
                  <div className='paragraph-small ms-1 ps-3'>{answer.explanation}</div>
                </div>
              )
            })
          )}
        </div>
      </Popover.Body>
    </Popover>
  )

  return (
    <div className='zocks-py-0.75 flex-1'>
      <OverlayTrigger trigger={['click']} placement='auto' overlay={popover} rootClose onToggle={setPopoverDisplayed}>
        <div className='d-flex'>
          <Tooltip className='zocks-text-gray-500 position-fixed' placement='top' title={popoverDisplayed ? '' : 'View match details'}>
            <div
              className={classNames(
                'd-flex gap-2 align-items-center px-2 py-1 border border-1 zocks-border-0.5 zocks-border-color-gray-300 cursor-pointer bg-white',
                matchClassName,
              )}
            >
              {matchIcon}
              <div className='paragraph-small medium'>{matchLabel}</div>
            </div>
          </Tooltip>
        </div>
      </OverlayTrigger>
    </div>
  )
}
